import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// Firebase 
import { auth, db, firestore, functions } from '../firebase.js'
import { onValue, ref } from "firebase/database"
import { query, getDocs, collection } from "firebase/firestore"
import { httpsCallable } from "firebase/functions"
import Papa from 'papaparse'
export default new Vuex.Store({
  state: {
    wareneingang: [],
    onTheRoad:[],
    lagerwerte: [],
    auftragseingang: [],
    altbestaende: [],
    altbestaendeStats: {
      gesamtartikel: 0,
      kritisch: 0,
      warnung: 0,
      gesamtwert: 0
    },
    datum: '28.01.2020',
    letzteAktualisierung: '00:00',
    isAdmin: false,
    isAdminAja: false,
    isAdminVizrt: false
  },
  mutations: {
    datum(state, datum) {
      state.datum = datum
    },
    wareneingang(state, wareneingang) {
      state.wareneingang = wareneingang
    },
    onTheRoad(state, onTheRoad) {
      state.onTheRoad = onTheRoad
    },
    lagerwerte(state, lagerwerte) {
      state.lagerwerte = lagerwerte
    },
    auftragseingang(state, auftragseingang) {
      state.auftragseingang = auftragseingang
    },
    altbestaende(state, altbestaende) {
      state.altbestaende = altbestaende
    },
    altbestaendeStats(state, stats) {
      state.altbestaendeStats = stats
    },
    isAdmin(state, isAdmin) {
      state.isAdmin = isAdmin
    },
    isAdminAja(state, isAdminAja) {
      state.isAdminAja = isAdminAja
    },
    isAdminVizrt(state, isAdminVizrt) {
      state.isAdminVizrt = isAdminVizrt
    }
  },
  actions: {
    setDatum({commit}, datum) {
      commit('datum', datum)
    },
    fetchWareneingang({commit}) {
      return new Promise(resolve => {
        onValue(ref(db, 'snapshots/wareneingang'), snapshot => {
          if (snapshot.val() !== null) {
            commit('wareneingang', snapshot.val())
          }
          console.log('fetchWareneingang done') // eslint-disable-line no-console
          resolve()
        })
      })
    },
    fetchOnTheRoad({commit}) {
      return new Promise(resolve => {
        onValue(ref(db, `uploads/onTheRoad`), snapshot => {
          if (snapshot.val() !== null) {
            commit('onTheRoad', snapshot.val())
          }
          console.log('fetchonTheRoad done') // eslint-disable-line no-console
          resolve()
        })
      })
    },
    async fetchLagerwerte({commit}) {
      const q = query(collection(firestore, "lagerwerte"));
      let data = []
      const snap = await getDocs(q);
      snap.forEach((doc) => {
        data.push(doc.data())
      });
      commit('lagerwerte', data)
      console.log('fetchLagerwerte done') // eslint-disable-line no-console
      return
    },
    fetchAuftragseingang({commit}) {
      return new Promise(resolve => {
        onValue(ref(db, 'snapshots/auftragseingang'), snapshot => {
          if (snapshot.val() !== null) {
            commit('auftragseingang', snapshot.val())
          }
          console.log('fetchAuftragseingang done') // eslint-disable-line no-console
          resolve()
        })
      })
    },
    fetchIsAdmin: async function({commit}) {
      const benutzer = auth.currentUser
      if (benutzer != null) {
        const claims = await benutzer.getIdTokenResult()

        claims.claims.admin = claims.claims.admin || false
        claims.claims.adminAja = claims.claims.adminAja || false
        claims.claims.adminVizrt = claims.claims.adminVizrt || false

        commit('isAdmin', claims.claims.admin)
        commit('isAdminAja', claims.claims.adminAja)
        commit('isAdminVizrt', claims.claims.adminVizrt)
      }
    },
    async fetchAltbestaende({commit}) {
      try {
        console.log('Starte fetchAltbestaende...')
        
        const readTextFile = httpsCallable(functions, "fetchOldStocks")
        const result = await readTextFile({ path: "oldStocks/altbestaende.txt" })
        
        const textContent = result.data.text
        console.log('Text geladen, Länge:', textContent.length)
        console.log('Erste 200 Zeichen:', textContent.substring(0, 200))

        const parsed = Papa.parse(textContent, {
          delimiter: '\t',
          skipEmptyLines: true,
          transform: (value) => value.trim()
        });
        
        console.log('Papa Parse Ergebnis:', parsed)
        console.log('Anzahl Zeilen:', parsed.data.length)
        
        if (parsed.data.length > 0) {
          const headers = parsed.data[0]
          const dataRows = parsed.data.slice(1)
          
          console.log('Headers:', headers)
          console.log('Anzahl Datenzeilen:', dataRows.length)
          
          // Transformiere die Daten in ein passendes Format
          const altbestaende = [];
            
          dataRows.filter(row => {
            const item = {}
            headers.forEach((header, index) => {
              item[header] = row[index] || ''
            })

            console.log(item);
            
            // Standardisiere Feldnamen (falls sie in der CSV anders sind)
            const mappedItem = {
              articleNumber: item.ArtNr || '',
              manufacturer: item['Sonderfeld 3'] || '',
              name: item.Bezeichnung || '',
              arrivalDate: item.Datum || '',
              quantity: parseInt(item.Lagermenge || 0),
              reservedQuantity: parseInt(item.Reserviert || 0),
              purchasePrice: parseFloat(item.EK_Preisliste || 0),
              value: 0, // Wird unten berechnet: Lagermenge * EK_Preisliste
              storagePeriod: parseFloat(item.Tage || 0),
              storageLocation: item.Lagerort || '',
            }

            // Berechne Wert (Lagermenge * Einkaufspreis)
            mappedItem.value = mappedItem.quantity * mappedItem.purchasePrice

            console.log(mappedItem);

            // Filtere Artikel mit Menge > 0 und ohne "POOL" im Artikelnamen
            if (
              mappedItem.quantity > 0 &&
              (
                mappedItem.storageLocation.match(/CTO_/) ||
                mappedItem.storageLocation.match(/ESD_/) ||
                mappedItem.storageLocation.match(/FU_/) ||
                mappedItem.storageLocation.match(/HR_/) ||
                mappedItem.storageLocation.match(/SKO_/) ||
                mappedItem.storageLocation.match(/CD_/)
              ) &&
              !mappedItem.articleNumber.match(/^-/) &&
              !mappedItem.articleNumber.match(/^\s/) &&
              !mappedItem.articleNumber.match(/^03/i) &&
              !mappedItem.articleNumber.match(/^04/i) &&
              !mappedItem.articleNumber.match(/^8-/i) &&
              !mappedItem.articleNumber.match(/^Abwicklung-/i) &&
              !mappedItem.articleNumber.match(/^Buchhaltung-/i) &&
              !mappedItem.articleNumber.match(/^Bosch-/i) &&
              !mappedItem.articleNumber.match(/^BRed/i) &&
              !mappedItem.articleNumber.match(/^Comline/i) &&
              !mappedItem.articleNumber.match(/^DIVERSES/i) &&
              !mappedItem.articleNumber.match(/^Einkauf/i) &&
              !mappedItem.articleNumber.match(/^Fachboden/i) &&
              !mappedItem.articleNumber.match(/^Parat/i) &&
              !mappedItem.articleNumber.match(/^Pool/i) &&
              !mappedItem.articleNumber.match(/^Vertrieb-/i)
            ) {
              altbestaende.push(mappedItem);
            }
            
          })
          
          console.log('Erste 3 transformierte Artikel:', altbestaende.slice(0, 3))
          
          // Berechne Statistiken
          const stats = {
            gesamtartikel: altbestaende.length,
            kritisch: altbestaende.filter(item => item.storagePeriod > 365).length,
            warnung: altbestaende.filter(item => item.storagePeriod >= 180 && item.storagePeriod <= 365).length,
            gesamtwert: altbestaende.reduce((sum, item) => sum + (item.value || 0), 0)
          }
          
          console.log('Berechnete Statistiken:', stats)
          
          commit('altbestaende', altbestaende)
          commit('altbestaendeStats', stats)
        } else {
          console.warn('Keine Daten in der Datei gefunden')
        }
        
        console.log('fetchAltbestaende erfolgreich abgeschlossen')
      } catch (error) {
        console.error('Fehler beim Laden der Altbestände:', error)
      }
    }
  }
})
